export default [{
	titulo: 'DOEM',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/doem',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]